import * as React from 'react';
import { Link } from 'react-router-dom';

export interface ListItemProps {
    data: any;
}

class ListItem extends React.Component<ListItemProps> {

    public trackExternal() {

        window.ga('send', 'event', 'externalJob', 'click', this.props.data.url, this.props.data.fe_user);
    }

    public render() {

        const refId = (this.props.data.label) ? this.props.data.label : this.props.data.uid;
        const contactImageUrl = (this.props.data.contact.image !== '')
            ? 'https://www.stellenanbieter.de/' + this.props.data.contact.image
            : 'https://www.stellenanbieter.de/fileadmin/anbieter_logos/logo_stellenanbieter_klein.png';

        const jobDateArray = this.props.data.date.split('-');
        const jobDate = jobDateArray[2] + '.' + jobDateArray[1] + '.' + jobDateArray[0];
        return (
            <div className="list-element" id={refId}>
                <div className="head">
                    <div className="logo">
                        {contactImageUrl !== '' && <img src={contactImageUrl} />}
                    </div>
                    <div className="proof">
                        {this.props.data.fe_user !== '6' &&
                            (this.props.data.usergroup === 'premium' || this.props.data.proofed === 'yes') ?
                            <a
                                href="https://www.stellenanbieter.de/fuer-stellenabieter/gepruefter-anbieter/"
                                title="Geprüfter Anbieter"
                            >
                                <img
                                    src="https://www.stellenanbieter.de/fileadmin/layout/pruefsiegel.png"
                                    alt="Geprüfter Anbieter"
                                />
                            </a>
                            :
                            <a
                                href="https://www.stellenanbieter.de/fuer-stellenabieter/gepruefter-anbieter/"
                                title="KEIN Geprüfter Anbieter"
                            >
                                <img
                                    src="https://www.stellenanbieter.de/fileadmin/layout/sign-909930_1280-100.png"
                                    alt="KEIN Geprüfter Anbieter"
                                />
                            </a>
                        }
                    </div>

                </div>
                <div className="content">
                    <h3>
                        {this.props.data.url.indexOf('http') !== -1
                            ? <a 
                                href={this.props.data.url} 
                                target="_blank" 
                                onClick={() => { this.trackExternal(); }}
                            >
                                {this.props.data.title_display}
                            </a>
                            : <Link to={`/jobs/stellenangebot/${this.props.data.url_intern}`}>
                                {this.props.data.title_display}
                            </Link>
                        }
                    </h3>
                    <div className="company">{this.props.data.company}</div>
                    <div className="location">{this.props.data.zip} {this.props.data.city}</div>
                    <div className="date">{jobDate}</div>
                </div>
                <div className="foot">
                    {this.props.data.url.indexOf('http') !== -1
                        ? <a 
                            href={this.props.data.url} 
                            target="_blank" 
                            onClick={() => { this.trackExternal(); }}
                        >
                            Zum Angebot
                        </a>
                        : <Link to={`/jobs/stellenangebot/${this.props.data.url_intern}`}>Zum Angebot</Link>
                    }
                </div>
            </div>
        );
    }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/ListItem.tsx